<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">新餐饮</div>
          <div class="contentBottom">
            <div>通过多样化智屏终端，打通业务链路，提升客户就餐体验。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">方案价值</div>
      <div class="lineCss"></div>
    </div>

    <div class="contentTextOne">从顾客和商家两方进行诉求分析，并提供场景化解决方案。餐客以高效等餐、舒心用餐为诉求；商家以高效售卖、坪效提升、客户黏性为目的。</div>
    <div class="planValue">
      <!-- start -->
      <div class="planValueTu">
        <div class="planValueLeft">
          <!-- <div class="planValueTitle">门店-场景化价值链路</div>
          <div class="lineBottom"></div>-->
          <!-- <div class="valueContent">
            <div>
              <span class="yellowIcon"></span>
              <span class="yellowRightFont">顾客行为旅程</span>
            </div>
            <div style=" margin-left: 30px;">
              <img :src="valueLeft" alt class="valueLeft">
            </div>
            <div>
              <span class="yellowRightFont">场景攻略</span>
              <span class="blackIcon"></span>
            </div>
          </div>-->
          <img :src="valueLeft" alt class="valueLeft">
        </div>
        <div class="planValueRight">
          <img :src="valueRight" alt class="valueLeft">
          <!-- <div class="planValueTitle">品牌-数据化运营策略</div>
          <div class="lineBottom"></div>-->
          <!-- <div class="valueContentTwo"> -->
          <!-- <div>
              <span class="yellowIcon"></span>
              <span class="yellowRightFont">内容运营</span>
          </div>-->
          <!-- <div class="valueFlex">
              <div class="valueFlexBox">
                <img :src="valueRight1" alt>
                <div>统一投放</div>
              </div>
              <div class="valueFlexBox">
                <img :src="valueRight2" alt>
                <div>分区域投放</div>
              </div>
              <div class="valueFlexBox">
                <img :src="valueRight3" alt>
                <div>定时播放</div>
              </div>
          </div>-->
          <!-- start -->
          <!-- <div style="margin-top:116px;">
              <span class="yellowIcon"></span>
              <span class="yellowRightFont">数据管理</span>
            </div>
            <div class="valueFlex">
              <div class="valueFlexBox">
                <img :src="valueRight4" alt>
              </div>
              <div class="valueFlexBox">
                <img :src="valueRight5" alt>
              </div>
              <div class="valueFlexBox">
                <img :src="valueRight6" alt>
              </div>
            </div>
            <div class="valueBottomFlex">
              <div class="valueBottomBox">用户头像</div>
              <div class="valueBottomBox toRightIcon">—></div>
              <div class="valueBottomBox">行为数据</div>
              <div class="valueBottomBox toRightIcon">—></div>
              <div class="valueBottomBox">转化率</div>
          </div>-->
          <!-- end -->
          <!-- </div> -->
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- end -->
    <!-- start -->
    <div class="changJing">
      <div class="titleBox">
        <div class="anliTitle" style="margin-top:118px">场景应用</div>
        <div class="lineCss"></div>
      </div>
      <!-- start -->
      <div class="titleCss">进店</div>
      <div class="retailFlex">
        <div class="retailBox widthCss">
          <img :src="retail1" alt>
        </div>
        <div class="retailBox widthCss">
          <img :src="retail2" alt>
        </div>
      </div>
      <!-- end -->
      <!-- 场景box start -->
      <div class="titleCss" style="margin-top:123px">点餐,买单</div>
      <div class="retailFlex">
        <div class="retailBox">
          <img :src="retail3" alt>
        </div>
        <div class="retailBox">
          <img :src="retail4" alt>
        </div>
        <div class="retailBox">
          <img :src="retail5" alt>
        </div>
      </div>
      <!-- 场景box end -->
      <div class="titleCss" style="margin-top:104px">用餐</div>
      <div class="retailFlex">
        <div class="retailBox widthCss">
          <img :src="retail6" alt>
        </div>
        <div class="retailBox widthCss">
          <img :src="retail7" alt>
        </div>
      </div>
    </div>
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">实施方案</div>
      <div class="lineCss"></div>
    </div>
    <!-- bottom start -->
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomTitle">有屏门店</div>
        <img :src="planLeftImg" alt>
        <div class="imgBottomTitle">原屏幕+数拓盒子</div>
        <div class="imgBottomText">
          通过HDMI线，让屏幕接入数拓智能盒子，联网后即可接入数拓云服务。
                        
        </div>
        <!-- <div class="bottomGrey">(V5只考虑展示需求，不考虑交互功能扩展)</div> -->
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img :src="rev5" alt>
            <div class="v5Css">V5</div>
          </div>
          <div class="imgBottomBox">
            <img :src="rev5" alt>
            <div class="v5Css">V8</div>
          </div>
        </div>
      </div>
      <div class="bottomRight">
        <div class="bottomTitle">无屏门店</div>
        <img :src="planRightImg" alt>
        <div class="imgBottomTitle">数拓商显一体机</div>
        <div class="imgBottomText">
          内置数拓智能播放系统，只需接电、联网，即可接入数拓云服务。
                        
        </div>
         <!-- <div class="bottomGrey" style="color:transparent;">
           (V5只考虑展示需求，不考虑交互功能扩展)
           </div> -->
        <div class="imgBottomFlex">
          <div class="imgBottomBox">
            <img :src="reYiTi" alt>
            <div class="v5Css">一体机</div>
          </div>
          <div class="imgBottomBox">
            <img :src="rePinJie" alt>
            <div class="v5Css">拼接屏</div>
          </div>
          <div class="imgBottomBox">
            <img :src="led" alt>
            <div class="v5Css">LED</div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:187px">典型案例</div>
      <div class="lineCss"></div>
    </div>
    <div class="anLiFlex">
      <div class="anLiBox">
        <img :src="anLiBoxImg3" class="anLiBigImg" alt>
      </div>
      <div class="anLiBox">
        <img :src="anLiBoxImg4" class="anLiBigImg" alt>
      </div>
    </div>
    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/newRetailTop.png";
import valueLeft from "@/assets/images/newFood1.png";
import valueRight from "@/assets/images/newFood2.png";
import valueRight1 from "@/assets/images/valueRight1.png";
import valueRight2 from "@/assets/images/valueRight2.png";
import valueRight3 from "@/assets/images/valueRight3.png";
import valueRight4 from "@/assets/images/valueRight4.png";
import valueRight5 from "@/assets/images/valueRight5.png";
import valueRight6 from "@/assets/images/valueRight6.png";

import retail1 from "@/assets/images/newFood3.png";
import retail2 from "@/assets/images/newFood4.png";
import retail3 from "@/assets/images/newFood5.png";

import retail4 from "@/assets/images/newFood6.png";
import retail5 from "@/assets/images/newFood7.png";
import retail6 from "@/assets/images/newFood8.png";
import retail7 from "@/assets/images/newFood9.png";
import boxImg5 from "@/assets/images/reChangJing5.png";
import boxImg6 from "@/assets/images/reChangJing6.png";

import planLeftImg from "@/assets/images/planLeftImg.png";
import planRightImg from "@/assets/images/planRightImg.png";
import bottomIcon1 from "@/assets/images/bottomIcon1.png";
import rev5 from "@/assets/images/rev5.png";
import reYiTi from "@/assets/images/reYiTi.png";
import rePinJie from "@/assets/images/rePinJie.png";
import led from "@/assets/images/led.png";

import anLiBoxImg3 from "@/assets/images/newFood12.png";
import anLiBoxImg4 from "@/assets/images/newFood13.png";

import Bread from "@/components/bread.vue";

export default {
  name: "PlanNewRestaurant",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["方案", "新餐饮"],
      retail1: retail1,
      retail2: retail2,
      retail3: retail3,
      retail4: retail4,
      retail5: retail5,
      retail6: retail6,
      retail7: retail7,
      reYiTi: reYiTi,
      rev5: rev5,
      rePinJie: rePinJie,
      led: led,
      bgImg: bgImg,
      valueLeft: valueLeft,
      valueRight: valueRight,

      valueRight1: valueRight1,
      valueRight2: valueRight2,
      valueRight3: valueRight3,
      valueRight4: valueRight4,
      valueRight5: valueRight5,
      valueRight6: valueRight6,

      boxImg5: boxImg5,
      boxImg6: boxImg6,
      planLeftImg: planLeftImg,
      planRightImg: planRightImg,
      bottomIcon1: bottomIcon1,

      anLiBoxImg3: anLiBoxImg3,
      anLiBoxImg4: anLiBoxImg4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}

/* end */
.contentTextOne {
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
  width: 70%;
  margin: auto;
  max-width: 1010px;
  margin-top: 82px;
  /* text-indent: 2em; */
  text-align: center;
}

.planValue {
  background: rgba(240, 240, 240, 1);
}

.paddingTop87 {
  padding-top: 87px;
}

.planValueTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  text-align: center;
  margin-top: 59px;
}

.planValueTu::after {
  content: "";
  display: block;
  clear: both;
}

.planValueTu {
  width: 70%;
  margin: auto;
  margin-top: 89px;
  padding: 70px 0;
}

.planValueLeft {
  width: 49%;
  float: left;
  background: #fff;
}

.planValueRight {
  width: 49%;
  float: right;
  background: #fff;
}

.lineBottom {
  height: 1px;
  background: rgba(240, 240, 240, 1);
}

.lineBottom {
  margin-top: 54px;
  margin-bottom: 36px;
}

.valueContent {
  padding: 0 30px;
  display: flex;
}

.yellowIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(252, 200, 0, 1);
}

.blackIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(49, 49, 49, 1);
}

.yellowRightFont {
  font-size: 1.8rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.valueContentTwo {
  padding: 0 30px;
}

.valueLeft {
  vertical-align: top;
  width: 100%;
}

.valueFlex {
  display: flex;
  justify-content: space-around;
}

.valueFlexBox {
  text-align: center;
  width: 33%;
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}

.valueFlexBox img {
  margin: 99px 0 30px;
}

.valueBottomFlex {
  display: flex;
  margin-bottom: 55px;
  width: 83%;
  margin: auto;
}

.valueBottomBox {
  font-size: 1.6rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  width: 20%;
  text-align: center;
}

.toRightIcon {
  color: #fcc800;
}

.boxTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin-top: 75px;
  margin-bottom: 68px;
}

.marginTop89 {
  margin-top: 89px;
}

.bottomTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
  margin: 70px 0 113px;
}

.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}

.bottomParent {
  width: 70%;
  min-width: 810px;
  margin: auto;
  margin-top: 86px;
  text-align: center;
}

.bottomLeft {
  width: 49%;
  float: left;
  border: 1px solid rgba(191, 191, 191, 1);
  height: 1065px;
}

.bottomRight {
  width: 49%;
  float: right;
  background: rgba(240, 240, 240, 1);
  height: 1065px;
}

.bottomRight img {
  max-height: 139px;
}

.imgBottomTitle {
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
  margin: 154px 0 56px;
}

.imgBottomText {
  width: 80%;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 39px;
}

.imgBottomFlex {
  display: flex;
  width: 80%;
  margin: auto;
}

.imgBottomBox {
  flex-grow: 1;
}

.imgBottomBox img {
  width: 90%;
  margin: 103px 0 10px;
  max-width: 70px;
}
.bottomGrey{
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(153, 153, 153, 1);
  line-height: 33px;
}
.v5Css {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.anLiFlex {
  display: flex;
  width: 70%;
  margin: auto;
  justify-content: space-between;
  margin-top: 85px;
}

.anLiBox {
  position: relative;
  width: 49%;
}

.positionText {
  position: absolute;

  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
}

.contentBgImg {
  width: 100%;
}

.tabBoxParent {
  width: 80%;
  max-width: 1205px;
  position: relative;
  margin: auto;
}

.tabFlex {
  width: 100%;
  max-width: 1205px;
  margin: auto;
  display: flex;
  position: absolute;
  bottom: 7px;
  left: calc(50% - 50%);
}

.tabBox {
  flex-grow: 1;
  text-align: center;
  font-size: 2.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 39px;
  position: relative;
}

.tobLineImgCss {
  position: absolute;
  right: 0;
  bottom: 2px;
}

.tabBoxText {
  margin-bottom: 20px;
  transition: 0.5s;
}

.tabBoxText:hover {
  color: #fcc800;
}
.reChangJingParent {
  width: 70%;
  margin: auto;
}
.reChangJingParent::after {
  content: "";
  display: block;
  clear: both;
}

.reChangJingLeft {
  width: 49%;
  float: left;
}
.reChangJingRight {
  width: 49%;
  float: right;
}
.reImgCss {
  width: 100%;
  /* max-width: 560px; */
}
.reImgText {
  text-align: center;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 73px;
}
.anLiBigImg {
  width: 100%;
  /* max-width: 550px; */
}
.titleCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  margin-top: 58px;
  margin-bottom: 22px;
}
.retailFlex {
  display: flex;
  justify-content: space-around;
  width: 70%;
  margin: auto;
}
.retailBox {
  width: 32%;
  text-align: center;
}
.retailBox img {
  width: 99%;
  /* max-width: 384px; */
}
.fuWuBox {
  text-align: center;
}
.fuWu {
  width: 50%;
  max-width: 589px;
}
.widthCss {
  width: 48%;
}
</style>



// WEBPACK FOOTER //
// src/view/PlanNewRestaurant.vue